export var IntelligentPhotoCaptureEstimatorCaptureFileSource;
(function (IntelligentPhotoCaptureEstimatorCaptureFileSource) {
    IntelligentPhotoCaptureEstimatorCaptureFileSource["CAMERA"] = "CAMERA";
    IntelligentPhotoCaptureEstimatorCaptureFileSource["GALLERY"] = "GALLERY";
})(IntelligentPhotoCaptureEstimatorCaptureFileSource || (IntelligentPhotoCaptureEstimatorCaptureFileSource = {}));
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorCaptureFileSource.js.map